export default [
  {
    title: '落地页预览',
    key: 'imageAddr',
    width: 120
  },
  {
    title: '落地页ID',
    key: 'pageId'
  },
  {
    title: '落地页名称（内部管理）',
    key: 'pageInnerName',
    width: 142,
    overflow: true
  },
  {
    title: '页面名称（外部显示）',
    key: 'pageName',
    width: 142,
    overflow: true
  },
  {
    title: '按钮下载类型',
    key: 'urlType'
  },
  {
    title: '游戏',
    key: 'gameNames',
    overflow: true,
    width: 242
  },
  {
    title: '更新时间',
    key: 'upTime',
    width: 108
  },
  {
    title: '创建人',
    key: 'createOpName'
  },
  {
    title: '更新人',
    key: 'upOpName'
  },
  {
    title: '操作',
    key: 'control',
    width: 100
  }
]
